module.exports = require("@agm/core/directives/map");